// src/utils/debugAuth.js
// Debug authentication issues

import { signInWithEmailAndPassword } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { auth, db } from '../config/firebase';

export const debugAuthentication = async () => {
  console.log('🔍 DEBUGGING HEALEHUB AUTHENTICATION...');
  
  try {
    // Step 1: Check Firebase connection
    console.log('1️⃣ Checking Firebase connection...');
    console.log('Auth available:', !!auth);
    console.log('Firestore available:', !!db);
    
    if (!auth || !db) {
      console.error('❌ Firebase not properly initialized');
      return { success: false, error: 'Firebase not initialized' };
    }
    
    // Step 2: Test authentication
    console.log('2️⃣ Testing authentication...');
    const email = 'chris@healehub.com';
    const password = 'Matrix=12';
    
    console.log('Attempting sign in with:', email);
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    const user = userCredential.user;
    
    console.log('✅ Authentication successful!');
    console.log('User UID:', user.uid);
    console.log('User email:', user.email);
    
    // Step 3: Check user profile
    console.log('3️⃣ Checking user profile...');
    const userDocRef = doc(db, 'users', user.uid);
    const userDoc = await getDoc(userDocRef);
    
    if (userDoc.exists()) {
      const profile = userDoc.data();
      console.log('✅ User profile found:', profile);
      
      // Step 4: Set up authentication state
      console.log('4️⃣ Setting up authentication state...');
      localStorage.setItem('HEALEHUB_DEBUG_AUTH', 'true');
      localStorage.setItem('HEALEHUB_USER_UID', user.uid);
      localStorage.setItem('HEALEHUB_USER_PROFILE', JSON.stringify(profile));
      
      console.log('🎉 Authentication debug complete - everything looks good!');
      console.log('🔄 Try refreshing the page and logging in again');
      
      return { 
        success: true, 
        user: user, 
        profile: profile,
        message: 'Authentication working correctly'
      };
      
    } else {
      console.error('❌ User profile not found in Firestore');
      return { success: false, error: 'User profile not found' };
    }
    
  } catch (error) {
    console.error('❌ Authentication debug failed:', error);
    console.error('Error code:', error.code);
    console.error('Error message:', error.message);
    
    return { 
      success: false, 
      error: error.message,
      code: error.code 
    };
  }
};

// Make available in browser console
window.debugAuth = debugAuthentication;
